<template>
  <s-t-b-y-lesson :lesson="lesson" :update="true" :disableSchool="true"></s-t-b-y-lesson>
</template>

<script>
  import STBYLesson from './components/STBYLesson';
export default {
  name: 'sb-lessons-edit',
  components: {STBYLesson},
  data() {
        return {
            lesson: {additionalInfo:{}},
        }
  },
  created(){
    this.getLesson(this.$route.params.id);
  },
  methods: {
    getLesson(id){
        this.stbyLessonRepo.show(id).then(response => {
            this.lesson = response.data.data;
          console.log(this.lesson);
          if(!this.lesson.additionalInfo){
            this.lesson.additionalInfo = {name:'', provider_id:'', provider_full_id:'', words:''};
          }
            if(this.lesson.school){
                this.lesson.school_id = this.lesson.school.id;
            }
        });
    },

  },
  watch: {

  }

}
</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/sb-lessons/Edit.vue